import startsWith from 'lodash/startsWith';

function matchId(url, reg, fn) {
  const matches = url.match(reg);
  if (matches && matches.length > 1) {
    const id = matches[1];
    return fn(id);
  }
  return undefined;
}

function makeYoutubeUrl(id) {
  return `https://www.youtube.com/embed/${id}?rel=0&autoplay=0&enablejsapi=0&wmode=opaque`;
}

function extractYoutubeId(url) {
  return (
    matchId(url, /.*youtube.*v=([a-zA-Z0-9_-]+).*/i, (id) => id) ||
    matchId(url, /.*youtu.be\/[^a-zA-Z0-9_-]*([a-zA-Z0-9_-]+).*/i, (id) => id)
  );
}

// TODO: later
// function extractVimeoEvent(url) {

//   return (
//     matchId(
//       url,
//       // vimeo.com/event/id
//       /.*vimeo.com\/event\/([^/]+)/i,
//       (id) => `https://vimeo.com/event/${id}/embed`,
//     ) ||
//     matchId(
//       url,
//       // other vimeo urls
//       /.*vimeo.*\/([a-zA-Z0-9_-]+).*/i,
//       (id) => `https://player.vimeo.com/video/${id}`,
//     )
//   );
// }

// function convertDailyMotionUrl(url) {
//   return matchId(
//     url,
//     /.*dailymotion.*\/video\/([a-zA-Z0-9]+)(_.*)?/i,
//     (id) => `https://www.dailymotion.com/embed/video/${id}`,
//   );
// }

function ensureVodalysEmbed(url) {
  if (url.indexOf('#?embedded') === -1) {
    return `${url}#?embedded=true`;
  }
  return url;
}

export function parseVideo(url) {
  if (!url) return undefined;

  // Check for vodalys
  if (url.match(/.*console.vodalys.studio.*/)) {
    return { type: 'iframe', url: ensureVodalysEmbed(url) };
  }

  if (url.match(/.*vimeo.*\/embed/) || url.match(/.*player.vimeo.com.*/)) {
    // Already an embed link, don't change anything
    return { type: 'vimeo', url };
  }

  const youtubeId = extractYoutubeId(url);
  if (youtubeId) {
    if (url.includes('embed')) {
      // Already an embed link, don't change
      return { type: 'iframe', url };
    }
    return { type: 'youtube', id: youtubeId, url: makeYoutubeUrl(youtubeId) };
  }
  if (url.match(/\.mp4$/i)) {
    return { type: 'video', url };
  }
  if (
    url.match(/clickmeeting/i) ||
    url.match(/blastream.com/i) ||
    url.match(/zoom.us/i) ||
    url.match(/appcraft\.events\/meet\/.*\/cm\//)
  ) {
    return { type: 'meeting', url };
  }
  if (startsWith(url, 'https://static.appcraft.events/live')) {
    // Auto-inject params if needed...
    if (!url.includes('userId=')) {
      const autoParams =
        'userId={userId}&firstName={firstName}&lastName={lastName}&thumbnail={thumbnail.uri}';
      const join = url.includes('?') ? '&' : '?';
      return { type: 'iframe', url: `${url}${join}${autoParams}` };
    }
  }
  return { type: 'iframe', url };
  // return convertYoutubeUrl(url) || convertVimeoUrl(url) || convertDailyMotionUrl(url) || url;
}
